import { BackgroundOperationStatus } from 'enums/BackgroundOperationStatus';
import { BackgroundOperationData } from 'interfaces/BackgroundOperation';
import { Action } from 'redux';

import {
    BackgroundOperationActionType,
    CancelBackgroundOperationAction,
    FinishBackgroundOperationAction,
    RemoveBackgroundOperationAction,
    StartBackgroundOperationAction,
    UpdateBackgroundOperationAction,
} from './backgroundOperations.actions';

const initialState = [] as BackgroundOperationData[];

export const backgroundOperationReducer = (
    state = initialState,
    action: Action<BackgroundOperationActionType>,
): typeof initialState => {
    switch (action.type) {
        case BackgroundOperationActionType.Start: {
            const operation = (action as StartBackgroundOperationAction).payload;
            return [...state, { ...operation, status: BackgroundOperationStatus.Running }];
        }

        case BackgroundOperationActionType.Update: {
            const operation = (action as UpdateBackgroundOperationAction).payload;
            const index = state.findIndex((op) => op.uuid === operation.uuid);

            if (index !== -1) {
                const newState = [...state];
                newState[index] = { ...state[index], ...operation };

                return newState;
            } else return state;
        }

        case BackgroundOperationActionType.Finish: {
            const uuid = (action as FinishBackgroundOperationAction).payload;
            const index = state.findIndex((op) => op.uuid === uuid);

            if (index !== -1) {
                const newState = [...state];
                newState[index] = {
                    ...state[index],
                    status: BackgroundOperationStatus.Finished,
                    progress: 1,
                };

                return newState;
            } else return state;
        }

        case BackgroundOperationActionType.Cancel: {
            const uuid = (action as CancelBackgroundOperationAction).payload;
            const index = state.findIndex((op) => op.uuid === uuid);

            if (index !== -1) {
                const newState = [...state];
                newState[index] = { ...state[index], status: BackgroundOperationStatus.Cancelled };

                return newState;
            } else return state;
        }

        case BackgroundOperationActionType.Remove: {
            const uuid = (action as RemoveBackgroundOperationAction).payload;
            const index = state.findIndex((op) => op.uuid === uuid);

            if (index !== -1) {
                return state.filter((op) => op.uuid !== uuid);
            } else return state;
        }

        default:
            return state;
    }
};
